import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** 1. GET cost centres not yet configured with an Overhead percentage */
export const getCCForOverhead = () =>
    axios.get(`${base}/Accounts/GetCCForODAccrued`, { params: { Otype: 'Overhead' } });

/** 2. GET cost centres already configured with an Overhead percentage */
export const getExistingCCForOverhead = () =>
    axios.get(`${base}/Accounts/GetExistingCCForODAccrued`);

/** 3. GET the currently configured Overhead percentage for a cost centre */
export const getCCOverheadPercent = (CCCvalue) =>
    axios.get(`${base}/Accounts/GetCCOverheadpercent`, { params: { CCCvalue } });

/** 4. GET the grid of all cost centres configured with an Overhead percentage */
export const getOverheadConfigGrid = () =>
    axios.get(`${base}/Accounts/GetCCAccurateDetails`, { params: { Type: 'Overhead' } });

/** 5. POST save/update the Overhead percentage for a cost centre (auto-upserts on the backend) */
export const saveCCOverheadValues = ({ CostCenter, Value, Createdby, Action, RoleId }) =>
    axios.post(`${base}/Accounts/SaveCCOverheadValues`, {
        Id: 0,
        ReportType: 'Overhead',
        CostCenter,
        Value,
        Createdby,
        Action,
        RoleId,
    });
